import { render } from "./comboFoodModel.vue?vue&type=template&id=749ba392"
import script from "./comboFoodModel.vue?vue&type=script&lang=js"
export * from "./comboFoodModel.vue?vue&type=script&lang=js"

import "./comboFoodModel.vue?vue&type=style&index=0&id=749ba392&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__